import { z } from 'zod';

export const MapPresignInputSchema = z
  .object({
    investmentId: z.string().uuid(),
    filename: z.string().min(1).max(255),
    size: z.number().int().positive().max(2 * 1024 * 1024),
    contentType: z.enum(['application/geo+json', 'application/json']),
  })
  .strict();
export type MapPresignInput = z.infer<typeof MapPresignInputSchema>;

export const ImagePresignInputSchema = z
  .object({
    investmentId: z.string().uuid(),
    filename: z.string().min(1).max(255),
    size: z.number().int().positive().max(8 * 1024 * 1024),
    contentType: z.enum(['image/jpeg', 'image/png']),
  })
  .strict();
export type ImagePresignInput = z.infer<typeof ImagePresignInputSchema>;

export const PresignResponseSchema = z.object({
  uploadId: z.string().uuid(),
  key: z.string(),
  presignedUrl: z.string().url(),
  headers: z.record(z.string()),
});
export type PresignResponse = z.infer<typeof PresignResponseSchema>;

export const MapConfirmInputSchema = z
  .object({
    uploadId: z.string().uuid(),
    geojson: z.record(z.any()),
  })
  .strict();
export type MapConfirmInput = z.infer<typeof MapConfirmInputSchema>;

export const ImageConfirmInputSchema = z
  .object({
    uploadId: z.string().uuid(),
    caption: z.string().max(500).optional(),
  })
  .strict();
export type ImageConfirmInput = z.infer<typeof ImageConfirmInputSchema>;

export const MapAttachmentSchema = z.object({
  id: z.string().uuid(),
  investmentId: z.string().uuid(),
  filePath: z.string(),
  originalFilename: z.string(),
  fileSizeBytes: z.number().int(),
  bbox: z.object({
    minLon: z.number(),
    minLat: z.number(),
    maxLon: z.number(),
    maxLat: z.number(),
  }),
  uploadedBy: z.string().uuid().nullable(),
  createdAt: z.string(),
});
export type MapAttachment = z.infer<typeof MapAttachmentSchema>;

export const ImageAttachmentSchema = z.object({
  id: z.string().uuid(),
  investmentId: z.string().uuid(),
  filePath: z.string(),
  thumbnailPath: z.string(),
  originalFilename: z.string(),
  mimeType: z.string(),
  fileSizeBytes: z.number().int(),
  widthPx: z.number().int().nullable(),
  heightPx: z.number().int().nullable(),
  caption: z.string().nullable(),
  takenAt: z.string().nullable(),
  exif: z.object({
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    orientation: z.number().nullable(),
  }),
  uploadedBy: z.string().uuid().nullable(),
  createdAt: z.string(),
});
export type ImageAttachment = z.infer<typeof ImageAttachmentSchema>;
